<template>
  <div class="order-detail">
    <div class="back">
      <!-- <div
        class="button el-icon-arrow-left"
        @click="toBack"
        style="background: #fff; margin-bottom: 10px"
      >
        关闭页面
      </div> -->
      <eui-btn
        type="secondary"
        style="margin-bottom: 10px"
        iconPosition="left"
        icon="eicon-arrow-left"
        @click="toBack(null)"
        >返回</eui-btn
      >
    </div>
    <div class="order-main container">
      <div class="common">
        {{ type == 'orderConfirm' ? '查看并确认' : '售后订单详情' }}
      </div>
      <el-form style="margin-top: 20px" ref="form" label-width="130px">
        <el-form-item class="form-item-title" label="基本信息"></el-form-item>
        <el-form-item label="订单编号：">{{ routeData.orderNo }}</el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="售后单编号：">{{
              routeData.aftersalesNo
            }}</el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="售后状态：">{{
              aftersalesStatus[Number(routeData.aftersalesStatus) - 1]
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="form-item-title" label="售后信息"></el-form-item>
        <el-form-item label="售后类型：">{{
          aftersalesType[Number(routeData.aftersalesType) - 1]
        }}</el-form-item>
        <el-form-item label="售后申请时间：">{{
          routeData.createTime
        }}</el-form-item>
        <el-form-item label="售后原因：">{{
          aftersalesReason[Number(routeData.aftersalesReason) - 1]
        }}</el-form-item>
        <el-form-item label="问题描述：">{{
          routeData.aftersalesDescription
        }}</el-form-item>
        <el-form-item label="联系人：">{{ routeData.contact }}</el-form-item>
        <el-form-item label="联系方式：">{{ routeData.mobile }}</el-form-item>
        <el-form-item
          label="收货地址："
          v-if="
            routeData.aftersalesType == '3' || routeData.aftersalesType == '5'
          "
          >{{ routeData.receiveAddress }}</el-form-item
        >
        <el-form-item label="照片附件：">
          <div class="box-image">
            <div class="block" v-for="item in imageList" :key="item.attachUrl">
              <el-image
                style="width: 100px; height: 100px"
                :src="item.attachUrl"
                :alt="item.attachName"
                :title="item.attachUrl"
                fit="fill"
              ></el-image>
            </div>
          </div>
        </el-form-item>

        <el-form-item
          class="form-item-title"
          label="售后商品清单"
        ></el-form-item>
      </el-form>
      <TableList
        style="margin-top: 16px"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template v-slot:defaultImage="tImg">
          <img
            :src="tImg.scope.row.productImage"
            style="width: 60px; height: 60px"
          />
        </template>
        <template v-slot:sumPrice="slot">
          ￥{{ slot.scope.row.sumPrice }}
        </template>
        <template v-slot:price="slot"> ￥{{ slot.scope.row.price }} </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="orderTagPage.currentPage"
          :page-size="orderTagPage.pageSize"
          :total="orderTagPage.pageTotal"
        >
        </el-pagination>
      </div>
      <div
        style="
          margin-top: 20px;
          width: 100%;
          text-align: right;
          margin-right: 20px;
        "
      >
        售后单总额：<span style="color: #f0250f">￥{{ orderTotalPrice }}</span>
      </div>
    </div>
    <div class="crumbs" v-if="type == 'orderConfirm'">
      <!-- 操作 -->
      <div style="float: right">
        <eui-btn type="secondary" @click="toBack(null)">返回</eui-btn>
        <eui-btn type="primary" @click="supplierOrderConfirm(false)"
          >拒绝</eui-btn
        >
        <eui-btn type="primary" @click="supplierOrderConfirm(true)"
          >确认</eui-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import api from '../../api/order';
import { mapState } from 'vuex';
import { BigNumber } from 'bignumber.js';
export default {
  components: { TableList },
  computed: { ...mapState(['USERINFO']) },
  data() {
    return {
      showFlag: false,
      aftersalesStatus: ['已提交', '已完成', '已拒绝', '已撤回'],
      aftersalesType: ['退款', '退货', '换货', '维修', '补货'],
      aftersalesReason: [
        '质量问题',
        '货物与订单不符',
        '下单时选择错误',
        '其他',
        '配件少送、漏件、破损',
      ],
      routeData: {},
      params: {},
      type: '',
      loading: false,
      tableData: [],
      imageList: [],
      tableLabel: [
        {
          label: '商品图片',
          param: 'productImage',
          align: 'center',
          width: '200',
          slot: 'defaultImage',
          fixed: 'left',
        },
        {
          label: '商品名称',
          param: 'productName',
          align: 'center',
          width: '200',
          fixed: 'left',
        },
        {
          label: '单价(含税)',
          param: 'price',
          align: 'center',
          width: '200',
          fixed: 'left',
          slot: 'price',
        },
        {
          label: '收货数量',
          param: 'settlementQuantity',
          align: 'center',
          fixed: 'left',
        },
        {
          label: '售后数量',
          param: 'quantity',
          align: 'center',
          fixed: 'left',
        },
        {
          label: '计量单位',
          param: 'unit',
          align: 'center',
          fixed: 'left',
        },
        {
          label: '售后金额',
          param: 'sumPrice',
          align: 'center',
          fixed: 'left',
          slot: 'sumPrice',
        },
      ],
      orderTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      orderTotalPrice: 0,
    };
  },
  mounted() {
    const baseData = JSON.parse(localStorage.getItem('afterSaleManageAffirm'));

    this.routeData = baseData;
    this.type = this.$route.query.type;
    this.params = {
      aftersalesId: this.routeData.aftersalesId,
      endTime: this.routeData.startTime,
      pageNum: this.orderTagPage.currentPage,
      pageSize: this.orderTagPage.pageSize,
      purchaseCompanyId: this.routeData.purchaseCompanyId,
      startTime: this.routeData.startTime,
    };
    this.queryAftersalesSkuPage();
    this.queryAftersalesAttach();
  },
  methods: {
    // 采购商撤回申请
    supplierOrderRefuse() {
      let params = {
        aftersalesId: this.routeData.aftersalesId,
        aftersalesStatus: this.routeData.aftersalesStatus,
        purchaseCompanyId: this.routeData.purchaseCompanyId,
      };
      api
        .callbackAftersales(params)
        .then((res) => {
          if (res.code == '200') {
            this.$message.success('操作成功!');
            this.toBack();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 查看商品详情
    queryAftersalesSkuPage() {
      api.queryAftersalesSkuPage(this.params).then((res) => {
        this.tableData = res.data.records;
        this.orderTagPage.pageTotal = res.data.total;
        this.tableData.forEach((item) => {
          let a = BigNumber(item.sumPrice);
          let b = BigNumber(this.orderTotalPrice);

          this.orderTotalPrice = a.plus(b).toNumber();
        });
      });
    },

    // 查看附件图片list
    queryAftersalesAttach() {
      let params = {
        aftersalesId: this.routeData.aftersalesId,
        purchaseCompanyId: this.routeData.purchaseCompanyId,
      };
      api.queryAftersalesAttach(params).then((res) => {
        this.imageList = res.data;
      });
    },

    handleSizeChange(pageSize) {
      this.orderTagPage.pageSize = pageSize;
      this.queryAftersalesSkuPage();
    },
    handleCurrentChange(currentPage) {
      this.orderTagPage.currentPage = currentPage;
      this.queryAftersalesSkuPage();
    },
    //完成确认
    async supplierOrderConfirm(flag) {
      //判断  入参 当前 供应商id  西域震坤行 限制   true 集成不显示，false 显示  ,createTime:submitTime
      await api
        .companyWhetherSystemIntegrationByCompanyId({
          companyId: this.USERINFO.companyId,
          createTime: this.routeData.createTime,
        })
        .then((res) => {
          if (res.code == '200') {
            this.showFlag = res.data;
          }
        });
      //供应商为集成对接供应商  ，询比价的可以操作  orderSource =4 || purchaseRequestType =4
      if (
        this.showFlag &&
        !(
          Number(this.routeData.orderSource) === 4 ||
          Number(this.routeData.purchaseRequestType) === 4
        )
      ) {
        return this.$message.warning(
          '您好，该供应商已做集成对接，请在贵方平台进行操作。'
        );
      }

      let params = {
        aftersalesId: this.routeData.aftersalesId,
        aftersalesStatus: this.aftersalesStatus.aftersalesStatus,
        auditFlag: flag,
        purchaseCompanyId: this.routeData.purchaseCompanyId,
      };
      api
        .auditAftersales(params)
        .then((res) => {
          if (res.code == '200') {
            this.$message.success('操作成功!');
            let times = new Date();
            times = times.getTime();
            this.toBack(times);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toBack(times) {
      if (times !== null) {
        this.$router.push({ path: '/afterSaleManage', query: { t: times } });
      } else {
        this.$router.push({ path: '/afterSaleManage' });
      }
      // this.$router.back();
    },
  },
  destroyed() {
    console.log('desssss')
  }
};
</script>

<style scoped lang="scss">
.order-detail {
  .tip {
    display: flex;
    justify-content: flex-end;
    color: #ef4c56;
    font-size: 12px;
    margin: 20px 0 10px 0;
  }
  .back {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .button {
      width: 110px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      cursor: pointer;
    }
    .operate {
      display: flex;
      .close {
        width: 126px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background: #ffe353;
        font-weight: 400;
        color: #333;
        text-align: center;
        cursor: pointer;
      }
      .refuse {
        background: #fff;
        margin-right: 20px;
      }
    }
  }
  .common {
    font-size: 14px;
    line-height: 14px;
    font-weight: bold;
    color: #333;
    font-style: normal;
  }
  .box-image {
    width: 720px;
    display: flex;
    flex-wrap: wrap;
    padding-left: 0px;
    margin-top: 10px;
    .block {
      display: block;
      margin-right: 20px;
    }
  }
  .form-item-title {
    background: #ededed;
  }
  .el-input {
    width: 30% !important;
  }
}
::v-deep.el-form-item {
  word-break: break-all;
}
</style>
